import { Routes } from '@angular/router';
import {
  BookingErrorPageComponent,
  BookingPageComponent,
  BookingWrapperComponent,
  CancelBookingPageComponent,
  RescheduleBookingPageComponent,
  StripePaymentCallbackComponent,
} from '@cf/features/booking';

export const bookingRoutes: Routes = [
  {
    path: '',
    component: BookingWrapperComponent,
  },
  {
    path: ':path/:duration',
    component: BookingPageComponent,
  },
  {
    path: 'cancel',
    component: CancelBookingPageComponent,
  },
  {
    path: 'error',
    component: BookingErrorPageComponent,
  },
  {
    path: 'reschedule',
    component: RescheduleBookingPageComponent,
  },
  {
    path: 'stripe-payment-callback',
    component: StripePaymentCallbackComponent,
  },
];
